import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

type VitalsTimerPayload = {
  encounterId: string;
};

function useResetVitalTimer(encounterId: string) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    ["resetVitalsTimer"],
    (payload: VitalsTimerPayload) => {
      return axiosChartInstance.post<{ encounterId: string }>(
        `v1/vitals/${encounterId}/timer-control/reset`,
        payload
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vitalsTimer", { encounterId }]);
      },
    }
  );
}

export { useResetVitalTimer };
